import { render } from "./admin_closing.vue?vue&type=template&id=b4e3ea82"
import script from "./admin_closing.vue?vue&type=script&lang=js"
export * from "./admin_closing.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__